import React from "react";
import clsx from "clsx";

export function Button({ className, variant = "primary", size = "md", disabled, loading, children, ...props }) {
  const base = "inline-flex items-center justify-center gap-2 font-heading font-semibold rounded-xl transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed";
  const variants = {
    primary: "bg-primary text-[#0A0F1E] hover:bg-primary-light shadow-ambient",
    secondary: "bg-white/[0.03] border border-white/15 text-white hover:bg-white/[0.08] hover:border-white/25",
    ghost: "text-slate-300 hover:text-white hover:bg-white/5",
    danger: "bg-red-500/90 text-white hover:bg-red-500",
    metallic: "bg-metallic-gold text-[#0A0F1E] hover:brightness-110",
  };
  const sizes = {
    sm: "text-xs px-3 py-2",
    md: "text-sm px-5 py-3",
    lg: "text-base px-7 py-4",
  };
  return (
    <button
      className={clsx(base, variants[variant], sizes[size], className)}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" /> : null}
      {children}
    </button>
  );
}
